var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f6f6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.528,6A2.537,2.537,0,0,0,6,8.528v8.944A2.537,2.537,0,0,0,8.528,20h8.944A2.537,2.537,0,0,0,20,17.472V8.528A2.537,2.537,0,0,0,17.472,6Zm0,1.167h8.944a1.353,1.353,0,0,1,1.361,1.361v.583H7.167V8.528A1.353,1.353,0,0,1,8.528,7.167ZM7.167,10.278H18.833v7.194a1.353,1.353,0,0,1-1.361,1.361H8.528a1.353,1.353,0,0,1-1.361-1.361Zm2.528,1.556a.972.972,0,1,0,.972.972A.972.972,0,0,0,9.694,11.833Zm3.306,0a.972.972,0,1,0,.972.972A.972.972,0,0,0,13,11.833Zm3.306,0a.972.972,0,1,0,.972.972A.972.972,0,0,0,16.306,11.833Zm-6.611,3.5a.972.972,0,1,0,.972.972A.972.972,0,0,0,9.694,15.333Zm3.306,0a.972.972,0,1,0,.972.972A.972.972,0,0,0,13,15.333Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.55dd6310b569e9c24ee4a1724ed14856.svg";
export { ForwardRef as ReactComponent };